import React from 'react';
import siteContent from '../../data/siteContent';

function Footer() {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="fw">
            ESTAMPAS <em>BRASIL</em>
          </div>
          <p>{siteContent.footer.description}</p>
        </div>

        <div>
          <h5>Menu</h5>
          <ul>
            <li><a href="#home">Início</a></li>
            <li><a href="#sobre">Sobre</a></li>
            <li><a href="#produtos">Produto</a></li>
          </ul>
        </div>

        <div>
          <h5>Contato</h5>
          <ul>
            <li>
              <a
                href={`https://wa.me/${siteContent.whatsapp.number}`}
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 Estampas Brasil. Todos os direitos reservados.
      </div>
    </footer>
  );
}

export default Footer;